/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

import { VVideo } from "vuetify/labs/VVideo";
// VIconBtn and VStepperVertical graduated from labs to stable in Vuetify 4.1,
// so they now import from "vuetify/components/*" (the labs paths were removed).
// VVideo is still a labs component.
import { VIconBtn } from "vuetify/components/VIconBtn";
// Vertical stepper — registered explicitly (like the others) so the tasks
// status view can show the lifecycle as a vertical stepper.
import { VStepperVertical, VStepperVerticalItem } from "vuetify/components/VStepperVertical";

// Styles
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";
import { aliases, mdi as svgSet } from "vuetify/iconsets/mdi-svg";
import { mdiSvgSet } from "./mdiIcons";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VIconBtn,
    VVideo,
    VStepperVertical,
    VStepperVerticalItem,
  },
  theme: {
    // Preserve existing theme selection logic (user preference or OS default)
    defaultTheme: localStorage.getItem("theme") || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"),
  },
  display: {
    // Restore v3 breakpoint thresholds to avoid layout shifts during migration
    thresholds: {
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  defaults: {
    VIcon: {
      style: "--v-icon-size-multiplier: 1.15",
    },
    VEmptyState: {
      style: "min-height: calc(100dvh - 148px); display: flex; align-items: center; justify-content: center",
    },
    // Restore v3 uppercase button text
    VBtn: {
      class: "text-uppercase",
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi: mdiSvgSet,
      svg: svgSet,
    },
  },
});
